export default {
  title: {
    en: 'Your password is weak',
  },
  text: {
    en: 'We highly recommend you to change password. To make it secure.',
  },
  confirmButton: {
    en: 'Change password',
  },
  cancelButton : {
    en: 'Close',
  },
}
